export default __webpack_public_path__ + "static/media/login.80cc7479.svg";